import { IThunkActionCreator } from '../../index';
import { getHistoryBasedSimilarOffers } from '../../../api/similar';
import { similarOffersReceived } from './similarOffersReceived';

export function requestHistoryBasedSimilarOffers(): IThunkActionCreator {
  return (dispatch, getState, context) => {
    // обработки ошибок нет, и это нормально — деградируем без показа блока
    return getHistoryBasedSimilarOffers(context.httpApi).then(res => {
      if (res.statusCode === 200) {
        dispatch(similarOffersReceived(res.response, 'historyBased'));
      }
    });
  };
}
